import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { Search } from 'lucide-react';
import { FC } from 'react';
import { useNavigate } from 'react-router';

export const EmptySearchResultHistory: FC<{
  onClearSearch: () => void;
}> = ({ onClearSearch }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('../');
  };

  return (
    <FlexCol alignItems="center" gap="4">
      <Search className="h-10 w-10 bg-neutral-100 rounded-md p-3" />
      <FlexCol gap="1" alignItems="center">
        <Text variant="header2" color="primary">
          No chats found
        </Text>
        <Text variant="body" color="secondary">
          Try different keywords, check for typos, or start a new chat
        </Text>
      </FlexCol>
      <FlexRow gap="2">
        <Button onClick={onClearSearch} variant="secondary" className="w-fit">
          Clear search
        </Button>
        <Button className="w-fit" variant="secondary" onClick={handleClick}>
          Start a new chat
        </Button>
      </FlexRow>
    </FlexCol>
  );
};
